import { useState, useEffect } from 'react';
import { SingleRoute, RouteStatus, RouteState } from '../../../Resources/Data/Routes';
import { TrailDifficulty } from '../../../Resources/Data/Trails';
import { routeService } from '../services/routeService';

export const useRoute = (id?: string) => {
  const [route, setRoute] = useState<SingleRoute>({
    id: 0,
    name: '',
    description: '',
    difficulty: TrailDifficulty.Easy,
    state: RouteState.Draft,
    status: RouteStatus.Pending,
    carType: undefined,
    type: undefined,
    time: '0 hours 0 minutes',
    distance: 0,
    elevationGain: 0,
    rating: 0,
    startingPoint: [0, 0],
    autoDetectedCountry: '',
    autoDetectedCity: '',
    reference: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy: 0,
    ownerId: 0,
    creator: { id: 0, name: '', email: '' },
    photos: [],
    tags: [],
    trailPath: [],
  });
  const [originalRoute, setOriginalRoute] = useState<SingleRoute>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    routeService.getRoute(id)
      .then((response) => {
        const routeData = response.data.route;
        setRoute(routeData);
        setOriginalRoute(routeData);
        setLoading(false);
      })
      .catch(() => {
        alert("Error loading route data");
        setLoading(false);
      });
  }, [id]);

  const setNewRouteValue = <K extends keyof SingleRoute>(
    key: K,
    value: SingleRoute[K]
  ) => {
    setRoute((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return {
    route,
    setRoute,
    originalRoute,
    setOriginalRoute,
    loading,
    setLoading,
    setNewRouteValue,
  };
};
